import { Input } from "antd";
import React, { memo, useCallback, useEffect, useState } from "react";
import { showErrorToast } from "../../utilities/toastUtils";
import useDebounce from "../../hooks/useDebounce";
import { useZoomContext } from "../../context/workbench/ZoomContext";

const ViewPortZoomInput = () => {
  const {zoomValue, getZoomValue, getWorkbenchZoomLevel} = useZoomContext();

  const [spinner, setSpinner] = useState(false);

	const debouncedValue = useDebounce(zoomValue, 1000);

	useEffect(() => {
		if (debouncedValue < 50 || debouncedValue > 200) {
			showErrorToast("Range Must Be Within 50-200");
		} else {
			// Update zoom level in context or redux
			getWorkbenchZoomLevel(debouncedValue / 100); // Scale to 0.5-2.0 range
		}
	}, [debouncedValue, getWorkbenchZoomLevel]);

	const handleZoomChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value, 10);
    if (value >= 50 && value <= 200) {
      getZoomValue(value);
    } else {
      showErrorToast("Range Must Be Within 50-200%");
    }
  }, [getZoomValue]);


  return (
    <Input
      type="number"
      min={50}
      max={200}
      step={5}
      onMouseOver={() => setSpinner(true)}
      onMouseLeave={() => setSpinner(false)}
      value={zoomValue.toFixed()}
      suffix="%"
      className={spinner ? "zooming-input" : "zooming-input-spinner"}
      onChange={handleZoomChange}
      onKeyDown={(e) => {
        if (e.key === ".") {
          e.preventDefault();
        }
      }}
    />
  );
};

export default memo(ViewPortZoomInput);
